import { render, staticRenderFns } from "./AutoCreateForm.vue?vue&type=template&id=3247dc23&"
import script from "./AutoCreateForm.vue?vue&type=script&lang=ts&"
export * from "./AutoCreateForm.vue?vue&type=script&lang=ts&"
import style0 from "./AutoCreateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports